export default __webpack_public_path__ + "static/media/operations.1d6e06f8.jpg";